module.exports = __webpack_public_path__ + "static/img/wap.ded0fd2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/en/北京通州华仁学校/wap.svg
// module id = qG7D
// module chunks = 16